import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const ExperienceWrapper = styled.article`
  width: 100%;
  .field-label {
    display: block;
    font-size: 16px;
  }

  .label-indication {
    font-weight: 300;
    font-size: 14px;
    opacity: 0.4;
  }
`
